import { useEffect, useState, useRef } from 'react';
import { Canvas, useThree } from '@react-three/fiber';
import { STLLoader } from 'three/examples/jsm/loaders/STLLoader';
import * as THREE from 'three';
import { OrbitControls, PerspectiveCamera } from '@react-three/drei';

const Model = ({ geometry }) => (
  <mesh geometry={geometry}>
    <meshStandardMaterial color="#abebffff" metalness={0.5} roughness={0.2} />
  </mesh>
);

const CameraController = ({ position, refreshFlag }) => {
  const { camera, gl } = useThree();
  const controlsRef = useRef();

  useEffect(() => {
    // Set camera position
    camera.position.set(position[0], position[1], position[2]);
    camera.lookAt(0, 0, 0);
    camera.updateProjectionMatrix();

    // Reset OrbitControls target
    if (controlsRef.current) {
      controlsRef.current.target.set(0, 0, 0);
      controlsRef.current.update();
    }
  }, [position, camera, refreshFlag]); // include refreshFlag to force reset

  return <OrbitControls ref={controlsRef} args={[camera, gl.domElement]} enableRotate={true} />;
};

const STLViewer = ({ url }) => {
  const [geometry, setGeometry] = useState(null);
  const [error, setError] = useState(null);
  const views = ['isometric', 'front', 'top', 'side'];
  const [currentViewIndex, setCurrentViewIndex] = useState(2); // default top
  const [refreshFlag, setRefreshFlag] = useState(false); // trigger for reset

  useEffect(() => {
    const fetchSTL = async () => {
      try {
        const res = await fetch(url);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const arrayBuffer = await res.arrayBuffer();

        const loader = new STLLoader();
        const geom = loader.parse(arrayBuffer);
        geom.computeBoundingBox();

        // Center geometry
        const center = new THREE.Vector3();
        geom.boundingBox.getCenter(center).negate();
        geom.translate(center.x, center.y, center.z);

        // Scale to fit viewport
        const size = new THREE.Vector3();
        geom.boundingBox.getSize(size);
        const maxDim = Math.max(size.x, size.y, size.z);
        const scale = 50 / maxDim; 
        geom.scale(scale, scale, scale);

        setGeometry(geom);
      } catch (err) {
        console.error('Failed to load STL:', err);
        setError('Failed to load STL');
      }
    };

    fetchSTL();
  }, [url]);

  if (error) return <div>{error}</div>;
  if (!geometry) return <div>Loading STL...</div>;

  const cameraPositions = {
    isometric: [70, 70, 70],
    front: [0, 0, 100],
    top: [0, 100, 0],
    side: [100, 0, 0]
  };

  

  const nextView = () =>
    setCurrentViewIndex((prev) => (prev + 1) % views.length);
  const prevView = () =>
    setCurrentViewIndex((prev) => (prev - 1 + views.length) % views.length);

  const refreshTopView = () => {
    setCurrentViewIndex(2); // top view
    setRefreshFlag((prev) => !prev); // toggle flag to force reset
  };

  const currentView = views[currentViewIndex];

  return (
    <div>
      <div style={{ marginBottom: 10 }}>
        {/* <button onClick={prevView}>◀</button>
        <span style={{ margin: '0 10px' }}>{currentView.toUpperCase()} VIEW</span>
        <button onClick={nextView}>▶</button> */}
        <button style={{ marginLeft: 20 }} onClick={refreshTopView}>🔄</button>
      </div>

      <div style={{ width: 1200, height: 650 }}>
        <Canvas style={{ width: '100%', height: '100%' }}>
          <ambientLight intensity={0.6} />
          <directionalLight position={[100, 100, 100]} intensity={1} />
          <PerspectiveCamera makeDefault fov={45} />
          <CameraController position={cameraPositions[currentView]} refreshFlag={refreshFlag} />
          <Model geometry={geometry} />
        </Canvas>
      </div>
    </div>
  );
};

export default STLViewer;
